import HeaderLeftMainLayout from "@/framework/layouts/HeaderLeftMainLayout";

import customerDetail from "@/pages/customerManagement/detail/index.vue";

import storeList from "@/pages/storeManagement/list/index.vue";
import listStore from "@/pages/storeManagement/listStore/index.vue";
import storeListCreate from "@/pages/storeManagement/listCreate/index.vue";
import storeAddPersonnel from "@/pages/storeManagement/add/addPersonnel/index.vue";
import storeAddStoreMessage from "@/pages/storeManagement/add/storeMessage/index.vue";
import storeAudit from "@/pages/storeManagement/toViewAudit/index.vue";

import personnelList from "@/pages/personnelManagement/list/index.vue";
import personnelAdd from "@/pages/personnelManagement/add/index.vue";
import personnelViewAudit from "@/pages/personnelManagement/toViewAudit/index.vue";

import purchaseAppointList from "@/pages/contractManagement/appoint/list.vue";
import purchaseAppointDetail from "@/pages/contractManagement/appoint/detail.vue";
import signature from "@/pages/contractManagement/signature/index.vue";
import contract from "@/pages/contractManagement/contract/index.vue";
import contractDetail from "@/pages/contractManagement/contract/detail.vue"
import {
  getRouterTitle
} from "@/framework/utils/tools.js"
//订单管理
import orderList from '@/pages/orderManage/index.vue'
import orderDetail from '@/pages/orderManage/detail.vue'

//对账管理
import billList from '@/pages/billManage/index.vue'
import billDetail from '@/pages/billManage/detail.vue'
import billExport from '@/pages/billManage/billExport.vue'
import billGoods from '@/pages/billManage/billGoods.vue'

//报表管理
import skuStockReport from '@/pages/reportManage/index.vue'

import bcRelationManagerment from '@/pages/bcRelationManagement/index.vue'

//分账管理
import accountSubject from '@/pages/splitAccountManage/index.vue'
import subjectBill from '@/pages/splitAccountManage/bill/index.vue'
import subjectBillDetail from '@/pages/splitAccountManage/bill/detail.vue'
import subjectDetail from '@/pages/splitAccountManage/detail.vue'
import subjectAdd from '@/pages/splitAccountManage/addSubject/index.vue'
import subjectCompany from '@/pages/splitAccountManage/company/index.vue'
import subjectCash from '@/pages/splitAccountManage/addCashAccount/index.vue'
import subjectBillRecord from '@/pages/splitAccountManage/bill/record.vue'

const myRoutes = [{
  path: "/",
  component: HeaderLeftMainLayout,
  redirect: 'customerManagement/detail',
  children: [
    {
      path: 'bcRelationManagerment/index',
      component: bcRelationManagerment,
      meta: {}
    },
    {
      path: 'orderManagement/list',
      component: orderList,
      meta: {
        keepAlive: true
      }
    },
    {
      path: 'orderManagement/detail',
      component: orderDetail,
      meta: {
        baseTitle: '订单列表',
        title: '订单详情',
        menu: '/orderManagement/list'
      }
    },
    {
      path: "customerManagement/detail",
      component: customerDetail,
      meta: {}
    },
    {
      path: "purchaseAppoint/list",
      component: purchaseAppointList,
      meta: {
        title: '供应链服务协议列表',
        keepAlive: true
      }
    },
    {
      path: "purchaseAppoint/detail",
      component: purchaseAppointDetail,
      meta: {
        baseTitle: '协议',
        title: '',
        menu: '/purchaseAppoint/list'
      },
      beforeEnter: (to, from, next) => {
        console.log('beforeEnter to', to)
        to.meta.title = getRouterTitle(to)
        next()
      }
    },
    {
      path: "contract/index",
      component: contract,
      meta: {
        title: '采购合同',
        keepAlive: true
      }
    },
    {
      path: "contract/detail",
      component: contractDetail,
      meta: {
        title: '合同详情',
        keepAlive: true
      }
    },
    {
      path: "signature/index",
      component: signature,
      meta: {
        title: '签章管理',
        keepAlive: true
      }
    },
    {
      path: "storeManagement/list",
      component: listStore,
      meta: {
        keepAlive: true,
      }
    },
    {
      path: "storeManagement/listCreate",
      component: storeListCreate,
      meta: {
        keepAlive: true,
      }
    },
    {
      path: "storeManagement/add/addPersonnel",
      component: storeAddPersonnel,
      meta: {
        title: "新增-关联人员",
        menu: "/storeManagement/list"
      }
    },
    {
      path: "storeManagement/add/storeMessage",
      component: storeAddStoreMessage,
      meta: {
        title: "新增-创建门店",
        menu: "/storeManagement/list"
      }
    },
    {
      path: 'storeManagement/toViewAudit',
      component: storeAudit,
      meta: {
        baseTitle: '门店',
        title: '',
        menu: '/storeManagement/list'
      },
      beforeEnter: (to, from, next) => {
        to.meta.title = getRouterTitle(to)
        next()
      }
    },
    {
      path: "personnelManagement/toViewAudit",
      component: personnelViewAudit,
      meta: {
        baseTitle: '人员',
        title: "",
        menu: "/personnelManagement/list"
      },
      beforeEnter: (to, from, next) => {
        to.meta.title = getRouterTitle(to)
        next()
      }
    },
    {
      name: 'memberList',
      path: 'personnelManagement/list',
      component: personnelList,
      meta: {
        keepAlive: true
      }
    },
    {
      path: 'personnelManagement/add',
      component: personnelAdd,
      meta: {
        title: '新增',
        menu: '/personnelManagement/list'
      }
    },
    {
      path: 'bills/list',
      component: billList,
      meta: {
        keepAlive: true
      }
    },
    {
      path: 'bills/detail',
      component: billDetail,
      meta: {
        baseTitle: '对账管理',
        title: '对账明细',
        menu: 'bills/detail'
      }
    },
    {
      path: 'bills/billExport',
      component: billExport,
      meta: {
        keepAlive: true
        // baseTitle: '对账管理',
        // title: '导出任务',
        // menu: 'bills/billExport'
      }
    },
    // {
    //   path: 'bills/billGoods',
    //   component: billGoods,
    //   meta: {
    //     keepAlive: true
    //     // baseTitle: '对账管理',
    //     // title: '商品汇总',
    //     // menu: 'bills/billGoods'
    //   }
    // },
    {
      path: 'reports/skustock',
      component: skuStockReport,
      meta: {
        keepAlive: true
      }
    },
    {
      path: 'splitAccount/list',
      component: accountSubject,
      meta: {
        keepAlive: true
      }
    },
    {
      path: 'splitAccount/bill',
      component: subjectBill,
      meta: {
        keepAlive: true
      }
    },
    {
      path: 'splitAccountManage/billDetail',
      component: subjectBillDetail,
      meta: {
        baseTitle: '主体账单',
        title: '账单详情',
        keepAlive: true
      }
    },
    {
      path: 'splitAccountManage/company',
      component: subjectCompany,
      meta: {
        baseTitle: '分账管理',
        title: '门店',
        keepAlive: true
      }
    },
    {
      path: 'splitAccountManage/addCash',
      component: subjectCash,
      meta: {
        baseTitle: '分账管理',
        title: '添加银行卡',
        keepAlive: true
      }
    },
    {
      path: 'splitAccountManage/detail',
      component: subjectDetail,
      meta: {
        baseTitle: '分账管理',
        title: '分账主体详情',
        keepAlive: true
      }
    },
    {
      path: 'splitAccountManage/addSubject',
      component: subjectAdd,
      meta: {
        baseTitle: '分账管理',
        title: '添加分账主体',
        keepAlive: true
      }
    },
    {
      path: 'splitAccountManage/billRecord',
      component: subjectBillRecord,
      meta: {
        baseTitle: '主体账单',
        title: '流水明细',
        keepAlive: true
      }
    },

  ]
}]

export default myRoutes;

/**
 * 路由配置示例：
 * https://router.vuejs.org/zh/guide/essentials/nested-routes.html
 *
 * 对于一些详情页的路由设置：
 * 添加路由 meta：menu，以便在打开详情页路由时，正确标识当前菜单项。
 * {
   path: '/demo/pages/table/select-table/:id',
   component: HeaderLeftMainLayout,
   children: [
     {
       path: '',
       meta: {
         title: '客户详情页',
         menu: '/demo/pages/table/select-table',
       },
       component: HelloWorld
     }
   ]
 }
 */